import { createContext } from 'react';

import { PersonSessionsCollection } from '@totem/components/services/remoteAccess/sessions/types';
import { RemoteAccessSessionsInput } from '@totem/components/services/remoteAccess/types';
import { Event } from '@totem/types/events';

interface Context {
  input: RemoteAccessSessionsInput;
  setInput: (input: RemoteAccessSessionsInput) => void;
  sessionData: PersonSessionsCollection;
  eventData: Event[];
}

export const getDefaultEndDate = () => {
  const endDate = new Date();
  return endDate;
};

export const getDefaultStartDate = () => {
  const startDate = getDefaultEndDate();
  startDate.setDate(startDate.getDate() - 30);
  return startDate;
};

export default createContext<Context>({
  input: null,
  setInput: () => {},
  sessionData: [],
  eventData: [],
});
